import React from 'react'
import NoticeItem, { INoticeItemProps } from './NoticeItem'
import { classNames } from '@dt/fe-utils'
import './index.scss'

class NoticeContainer extends React.Component {
  state = {
    noticeList: [] as INoticeItemProps[],
  }

  _getNoticeId = () => {
    return `notice-container${new Date().getTime()}${
      this.state.noticeList.length
    }`
  }

  addNotice = (noticeProps: INoticeItemProps) => {
    const { noticeList } = this.state
    const noticeId = this._getNoticeId()
    noticeList.push({
      ...noticeProps,
      id: noticeId,
    })
    this.setState({
      noticeList: noticeList,
    })
    return noticeId
  }

  deleNotice = (id?: string) => {
    const { noticeList } = this.state
    this.setState({
      noticeList: noticeList.filter((item) => item.id !== id),
    })
  }

  render () {
    const { noticeList } = this.state
    return (
      <div className='notice-container'>
        <div
          className={classNames(
            {
              'notice-wrap': true,
              'notice-show': noticeList.length,
              'notice-mask': noticeList.length && noticeList[0].mask,
            }
          )}
        >
          {noticeList.reverse().map((item) => (
            <NoticeItem {...item} onClose={this.deleNotice} key={item.id} />
          ))}
        </div>
      </div>
    )
  }
}

export default NoticeContainer
